export const oppgaveFrontendProject = "HN.Oppgave.Frontend";
